import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ACLService } from './acl.service';

export interface Footer {
    sticky?:boolean
    footerButton?:FooterButton[]
}

export interface FooterButton {
    title: string;
    color?:string;
    acl?:string[];
    disabled?:boolean;
    buttonClass?:string[];
    action?: FooterAction;
}

export interface FooterAction {
    url?: string;
    parms?: {};
    function?: Function;
}

@Injectable()
export class FooterService {
    public footer: Footer;

    constructor( private router: Router,
        private aclService: ACLService
        ) {
        this.footer = {} as Footer;
    }

    public callBackFunction(action: FooterAction) {
        if (!action) {
            return;
        }

        if (action.function) {
            action.function();
        }

        if (action.url) {
            const navigationExtras: NavigationExtras = {
                queryParams: action.parms || {},
            };

            this.router.navigate([action.url], navigationExtras);
        }
    }

    public getFooterMenuACL(){
        let permissionList = this.footer.footerButton?.flatMap(x=>x.acl);
        //mean either got 1 footer button don have acl apply mean it have the footer menu frame
        if(permissionList?.some(x=>!x)){
            return true;
        }
        return this.aclService.userPermissionChecking(permissionList);
    }

    public getFooterButtonACL(acl:string[]){
        if(acl?.length>0){
            return this.aclService.userPermissionChecking(acl);
        }else{
            // don have value mean the footer button don have acl apply
            return true;
        }
    }

}
